// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/trapped-gas.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/trapped-gas/trapped-gas.js';

mount([g0]);
